import { createFileRoute } from "@tanstack/react-router";
import NotificationsPage from "@/site/pages/notifications";

// Old app's notification settings lived at /notifications — keep the URL (PRD 07).
export const Route = createFileRoute("/notifications")({
  component: NotificationsPage,
});
